import { notificationsApi } from '@/api/powerMarkets/notificationsApi.ts';
import { useLiveTableStore } from '@/stores/powerMarkets/liveTableStore.ts';

interface INotificationsActions {
    markNotificationsSeen: () => void;
}

const useNotificationsActions = (): INotificationsActions => {
    const liveTableStore = useLiveTableStore();

    function markNotificationsSeen (): void {
        notificationsApi.markNotificationsAsSeen();
        liveTableStore.markNotificationsSeenLocally();
    }

    return {
        markNotificationsSeen,
    };
};

export { useNotificationsActions };
